import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { JSException } from "../common/messages.js";
import ErrorStackParser from 'error-stack-parser';

function getDefaultStack(e) {
  return [{
    columnNumber: e.colno,
    lineNumber: e.lineno,
    fileName: e.filename,
    functionName: "",
    source: ""
  }];
}

export function getExceptionMessage(error, fallbackStack) {
  var stack = fallbackStack;

  try {
    stack = ErrorStackParser.parse(error);
  } catch (e) {}

  return new JSException(error.name, error.message, JSON.stringify(stack));
}
export function getExceptionMessageFromEvent(e) {
  if (e instanceof ErrorEvent) {
    if (e.error instanceof Error) {
      return getExceptionMessage(e.error, getDefaultStack(e));
    } else {
      var _e$message$split = e.message.split(':'),
          _e$message$split2 = _slicedToArray(_e$message$split, 2),
          name = _e$message$split2[0],
          message = _e$message$split2[1];

      if (!message) {
        name = 'Error';
        message = e.message;
      }

      return new JSException(name, message, JSON.stringify(getDefaultStack(e)));
    }
  } else if ('PromiseRejectionEvent' in window && e instanceof PromiseRejectionEvent) {
    if (e.reason instanceof Error) {
      return getExceptionMessage(e.reason, []);
    } else {
      var _message;

      try {
        _message = JSON.stringify(e.reason);
      } catch (_) {
        _message = String(e.reason);
      }

      return new JSException('Unhandled Promise Rejection', _message, '[]');
    }
  }

  return null;
}
export default function (app, opts) {
  var options = Object.assign({
    captureExceptions: true
  }, opts);

  if (options.captureExceptions) {
    var handler = function handler(e) {
      var msg = getExceptionMessageFromEvent(e);

      if (msg != null) {
        app.send(msg);
      }
    };

    app.attachEventListener(window, 'unhandledrejection', function (e) {
      return handler(e);
    });
    app.attachEventListener(window, 'error', function (e) {
      return handler(e);
    });
  }
}